import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { UseFormProps, UseFormReturn } from 'react-hook-form';

interface FormContextValue {
	control: UseFormReturn;
	options: UseFormProps;
	successMessage: null | string;
	submitError: boolean | string;
	setSubmitError: Dispatch<SetStateAction<string | boolean>>;
	disabledSubmitButtonWhenClean: boolean;
	disabledSubmitButtonWhenInvalid: boolean;
}

export const FormContext = createContext<FormContextValue | undefined>(undefined);

export function useFormContext(): FormContextValue | undefined {
	return useContext(FormContext);
}
